import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ComingSoonPage from "./ComingSoonPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsAndConditionsPage from "./pages/TermsAndConditionsPage";
import "./App.css";

const App = () => {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<ComingSoonPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsAndConditionsPage />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
